import "../../../../../css/CashflowModeller2/Buttons/RemoveButton.css"; // Import your CSS file
import { useState } from "react";

/**
 * RemoveButton component renders a styled button for removing items.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.buttonText - The text to display on the button (currently unused, defaults to "Remove").
 * @param {boolean} props.isDisabled - If true, disables the button and applies a disabled style.
 * @param {function} [props.onClick] - Optional callback function to execute when the button is clicked.
 *
 * @returns {JSX.Element} The rendered RemoveButton component.
 */
const RemoveButton = ({ buttonText,isDisabled, onClick }) => {
  const [clicked, setClicked] = useState(false);
  // const handleClick = () => {
  //   navigate(link); // Navigate to the provided link
  // };

  return (
    <>
    <div
      className={`removeButton ${isDisabled ? "disabled" : ""} `}
      onClick={() => {
        setClicked(!clicked); // Toggle the clicked state
        // handleClick();
        onClick && onClick();
      }}
    >
      <div className="Text-Remove">Remove</div>
    </div>
    
    </>
  );
};

export default RemoveButton;
